import loadExternalResource from "./loadExternalResource";

function isFbHack(src) {
    try {
        const url = new URL(src);
        return url.host === "connect.facebook.net";
    } catch (error) {
        return false;
    }
}

function loadTag(src, callback) {
    const selector = `script[src="${src}"]`;
    const element = document.createElement("script");
    element.src = src;
    element.async = true;
    loadExternalResource(selector, element, callback);
}

export default function loadExternalScript(src, callback) {
    if (isFbHack(src)) {
        function onIgReady() {
            loadTag(src, callback);
        }

        loadExternalScript("https://www.instagram.com/embed.js", onIgReady);
    } else {
        loadTag(src, callback);
    }
}
